export default __webpack_public_path__ + "static/media/allIn.bf260a15.mp3";